<template>
  <div class="preview">
    <van-image-preview v-model="showPreview"
                       :startPosition="startPosition"
                       :images="imgList" >
    </van-image-preview>
    <div class="img_list">
      <img :src="item"
          :class="oneLine ? 'img_one_item'  : 'img_item'  "
           @click.stop="showPreviewImg(item,index)"
           v-for="(item,index) in imgList"
           :key="index">
    </div>
  </div>
</template>

<script>
import Empty from "@/components/Empty";
import List from "@/components/List";
export default {
  name: "preview",
  components: {
    Empty,
    List
  },
  props: {
    imgList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    oneLine: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showPreview: false,
      startPosition: 0
    };
  },
  created () {
  },
  methods: {
    showPreviewImg (item, index) {
      this.showPreview = true;
      this.startPosition = index;
      // this.$set(item, 'showPreview', true)
    }
  }
};
</script>

<style lang="scss" scoped>
.preview {
  .img_list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .img_item {
      height: 160px;
      width: 160px;
      border-radius: 5px;
      margin-bottom: 20px;
      &:nth-child(3n-1) {
        margin: 0 40px;
      }
    }
    .img_one_item{
      height: auto;
      max-width: 100%;
      border-radius: 5px;
      margin-bottom: 20px;
      // &:nth-child(3n-1) {
      //   margin: 0 40px;
      // }
    }
  }
}
</style>
